import React from "react";
import Frame from "../../../../../Frame/index.js";
import { BaggageSegment } from "../../../../../IncludedBaggage/components/BaggageSegment.js";
const IncludedBaggageList = ({ flightSegments, includedProducts, hideIncludedSection }) => {
    const { segments: baggageSegments, areAllSegmentsIdentical } = includedProducts;
    return (React.createElement(React.Fragment, null, baggageSegments.map((baggageSegment, index) => {
        const isLastSegment = index === baggageSegments.length - 1;
        if (baggageSegment.length > 0) {
            return (React.createElement(Frame, { mb: isLastSegment ? 0 : 1, key: index, attributes: { "data-testid": `included_baggage_${index}` } },
                React.createElement(BaggageSegment, { flightSegment: flightSegments[index], baggageSegment: baggageSegment, showHeader: !areAllSegmentsIdentical, hideIncludedSection: hideIncludedSection })));
        }
        else {
            return null;
        }
    })));
};
export default IncludedBaggageList;
